import { Icon } from '@timeedit/ui-components';
import { Button, Dropdown, Input } from '@timeedit/ui-components/antd';
import intl from '../../i18n/intl';

type Props = {
  onSearch: any;
  menu?: any;
};

const language: any = intl.messages;

export const ListSearch = ({ onSearch = () => {}, menu }: Props) => {
  return (
    <div className="search-wrapper">
      <Input.Search
        size="small"
        placeholder={language.search}
        onSearch={(value: string) => onSearch(value)}
        onPressEnter={(event: any) => onSearch(event.target.value)}
        allowClear
      />
      {menu && (
        <Dropdown menu={menu} className="search-dropdown">
          <Button
            size="small"
            type="default"
            icon={<Icon id="DownOutlined" alt="Down" />}
          />
        </Dropdown>
      )}
    </div>
  );
};
